// extracted by mini-css-extract-plugin
export default {"wrapper":"SuggestedUsers_wrapper__EOWBE","heading":"SuggestedUsers_heading__wow8Y"};